import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FullScreenPortal } from 'components/FullScreenPortal/FullScreenPortal';
import { ReactComponent as CloseIcon } from 'assets/icons/close_menu.svg';
import { ReactComponent as UserIcon } from 'assets/icons/user_button.svg';
import AiAssistant, { AI_WIDGET_THEMES } from 'new-ui/Components/AiAssistent';
import NotePadIcon from 'assets/icons/note.svg';
import { useTranslation } from 'utils/modifiedTranslation';
import { MenuItems } from './MenuItems';
import styles from './mobileMenu.module.css';
import menuItemsStyles from './mobileMenuItems.module.css';

export const MobileMenu = ({
  tabIds,
  isOpen,
  onMobileMenuItemClick,
  userCondition,
  isAuthenticated,
  activeItem,
  toggleMobileMenu,
  isUploadButtonShown,
  isProfileButtonShown,
  onProfileButtonClick,
}) => {
  const { t } = useTranslation();
  return (
    <FullScreenPortal nonePointerEvents={!isOpen}>
      <div className={cx(styles.root, { [styles.isVisible]: isOpen })}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={toggleMobileMenu}
        >
          <CloseIcon />
        </button>
        <div>
          <MenuItems
            tabIds={tabIds}
            onMenuItemClick={onMobileMenuItemClick}
            isAuthenticated={isAuthenticated}
            activeItem={activeItem}
            userCondition={userCondition}
            classes={menuItemsStyles}
          />
          {isUploadButtonShown && (
            <div className={styles.uploadButtonWrapper}>
              <AiAssistant
                theme={AI_WIDGET_THEMES.DARK}
                customUploadIcon={NotePadIcon}
                customUploadLabel={t('ai_profile.upload_button')}
              />
            </div>
          )}
          {isProfileButtonShown && (
            <button
              type="button"
              className={styles.profileButton}
              onClick={onProfileButtonClick}
            >
              <UserIcon />
              <span className={styles.profileButtonLabel}>
                {t('general.navbar.profile')}
              </span>
            </button>
          )}
        </div>
      </div>
    </FullScreenPortal>
  );
};

MobileMenu.propTypes = {
  tabIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isProfileButtonShown: PropTypes.bool.isRequired,
  isUploadButtonShown: PropTypes.bool.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  onMobileMenuItemClick: PropTypes.func.isRequired,
  userCondition: PropTypes.string,
  activeItem: PropTypes.string,
  onProfileButtonClick: PropTypes.func.isRequired,
};
